import { d001 } from './001'
import { d002 } from './002'
import { d003 } from './003'

export const designs = [d001, d002, d003]
